import { render, staticRenderFns } from "./createSubCompetencyModal.vue?vue&type=template&id=5f93f70e&"
import script from "./createSubCompetencyModal.vue?vue&type=script&lang=js&"
export * from "./createSubCompetencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports